export const setVideo = 'setVideo'
export const setMostRecentNotification = 'setMostRecentNotification'
export const addNewNotifications = 'addNewNotifications'

export const addVideo = 'addVideo'

export const notify = 'notify'

export const logout = 'logout'
export const updateUser = 'updateUser'

export const setUnsharingTeamShare = 'setUnsharingTeamShare'

export const removeTeam = 'removeTeam'

export const setErrorSocialLogin = 'setErrorSocialLogin'

export const removeProviderByID = 'removeProviderByID'

export const updateSocialConnections = 'updateSocialConnections'

export const setLoginErrorMessage = 'setLoginErrorMessage'



// WEBPACK FOOTER //
// ./src/mutationTypes.js